/**
 * Footer: Archive overview (ungated)
 */

import { esc, fmtCompact } from './shared.js';

export function renderOverview(result) {
  const modelEntries = Object.entries(result.modelDistribution)
    .sort((a, b) => b[1] - a[1]);

  const gizmoCount = Object.keys(result.gizmoInventory).length;

  // Use adjusted total (text + images + tool calls + system) for consistency with X-Ray
  const adjustedTotalTokens = result.conversations.reduce((s, c) => {
    const at = c.adjustedTokens;
    return s + at.textTokens + at.imageTokens + at.toolCallTokens + at.systemTokens;
  }, 0);

  const totalImages = result.conversations.reduce((s, c) => s + (c.imageCount || 0), 0);
  const totalImageTokens = result.conversations.reduce((s, c) => s + (c.imageTokens || 0), 0);
  const totalUserImages = result.conversations.reduce((s, c) => s + (c.userImageCount || 0), 0);
  const totalGenImages = result.conversations.reduce((s, c) => s + (c.generatedImageCount || 0), 0);
  const imageTokenPct = adjustedTotalTokens > 0 ? (totalImageTokens / adjustedTotalTokens * 100).toFixed(1) : '0.0';

  return `
    <section class="section" id="section-overview">
      <div class="section-label">By the Numbers</div>
      <div class="section-title">Archive overview</div>

      <div class="metric-grid">
        <div class="metric-card">
          <div class="metric-label">Total chats</div>
          <div class="metric-value">${result.totalConversations.toLocaleString()}</div>
        </div>
        <div class="metric-card">
          <div class="metric-label">Total messages</div>
          <div class="metric-value">${result.totalMessages.toLocaleString()}</div>
        </div>
        <div class="metric-card">
          <div class="metric-label">Estimated tokens</div>
          <div class="metric-value">${fmtCompact(adjustedTotalTokens)}</div>
        </div>
        <div class="metric-card">
          <div class="metric-label">Archive size</div>
          <div class="metric-value">${(result.archiveSizeBytes / (1024 * 1024)).toFixed(0)}<span class="unit">MB</span></div>
        </div>
        <div class="metric-card">
          <div class="metric-label">Archive span</div>
          <div class="metric-value">${Math.round(result.chatgptTax.archiveSpanDays)}<span class="unit">days</span></div>
        </div>
        <div class="metric-card">
          <div class="metric-label">Custom GPTs used</div>
          <div class="metric-value">${gizmoCount}</div>
        </div>${totalImages > 0 ? `
        <div class="metric-card">
          <div class="metric-label">Images</div>
          <div class="metric-value">${totalImages.toLocaleString()}</div>
          <div class="metric-detail">${totalUserImages} uploaded / ${totalGenImages} generated</div>
        </div>
        <div class="metric-card">
          <div class="metric-label">Image tokens</div>
          <div class="metric-value">${fmtCompact(totalImageTokens)}</div>
          <div class="metric-detail">${imageTokenPct}% of total</div>
        </div>` : ''}
      </div>

      ${modelEntries.length > 0 ? `
        <div class="subsection">
          <div class="section-label">Model distribution</div>
          <div class="table-wrap">
            <table class="data-table">
              <thead>
                <tr><th>Model</th><th>Chats</th><th>Share</th></tr>
              </thead>
              <tbody>
                ${modelEntries.map(([slug, count]) => `
                  <tr>
                    <td>${esc(slug)}</td>
                    <td class="num">${count}</td>
                    <td class="num">${(count / result.totalConversations * 100).toFixed(0)}%</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
        </div>
      ` : ''}
    </section>
  `;
}
